import { useEffect, useRef } from 'react';

import { snakeCase } from 'lodash';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { useSeriesScrollPosition } from '../../hooks/useSeriesScrollPosition';
import {
  LessonCardContainer,
  LessonImage,
  Title,
  IconContainer,
  CardBottom,
  CircleCheckIcon,
  StyledWatchLaterIcon,
  Status, ContinueButton, ButtonContainer
} from './styled';

const EDU_CARD_SELECTED = 'edu_card_selected';
const J2S_SERIES = 'entrepreneurial_mindset';

const LessonCard = ({ lesson, focusCard }) => {
  const cardRef = useRef();

  const {
    saveSelectedCard,
    focusSelectedCard
  } = useSeriesScrollPosition(cardRef, EDU_CARD_SELECTED, J2S_SERIES, snakeCase(lesson.name));

  const navigate = useNavigate();

  const handleClick = () => {
    if (lesson.nextStepURL) {
      saveSelectedCard();
      navigate(lesson.nextStepURL);
    }
  };

  useEffect(() => {
    if (focusCard) focusSelectedCard();
  }, [focusCard, focusSelectedCard]);

  return (
    <LessonCardContainer ref={cardRef}>
      <LessonImage
        alt={`${lesson.name} Image`}
        src={lesson.thumbnail}
      />
      <CardBottom>
        <Title size="lg" bold>{lesson.title}</Title>
        <ButtonContainer>
          <IconContainer isCompleted={lesson.isCompleted} isInProgress={lesson.isInProgress}>
            {lesson.isCompleted
              ? <CircleCheckIcon isCompleted={lesson.isCompleted} />
              : <StyledWatchLaterIcon isCompleted={lesson.isCompleted} />}
            <Status color="focus60">{lesson.isCompleted ? 'Completed' : 'In progress'}</Status>
          </IconContainer>
          {!lesson.isCompleted && (
          <ContinueButton size="small" onClick={handleClick}>
            {lesson.isInProgress ? 'Resume' : 'Start'}
          </ContinueButton>
          )}
        </ButtonContainer>
      </CardBottom>
    </LessonCardContainer>
  );
};

LessonCard.propTypes = {
  lesson: PropTypes.shape({
    name: PropTypes.string,
    thumbnail: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    isInProgress: PropTypes.bool,
    isCompleted: PropTypes.bool,
    nextStepURL: PropTypes.string
  }),
  focusCard: PropTypes.bool
};

LessonCard.defaultProps = {
  focusCard: false
};

export default LessonCard;
